import * as yup from 'yup';

export default yup.object({
    topic_name: yup.string().trim().required('Name is a required field'),
    topic_summary: yup.string().trim().required('Summary is a required field')
});
